export const getAvatarImage = (reader: any) => {
    const base64data = reader?.result ?? "";
    const image: string =
      typeof base64data === "string"
        ? base64data
        : Buffer.from(base64data).toString();
        return image
  };